<template>
    <div class="copy">Hello {{user ? user.name : ''}}, you’ve earned <strong>{{user ? '$'+user.cash_earned : ''}} </strong></div>
</template>

<script>
export default {
    name: 'PointsCopyComponent',
    data(){
        return {
            user: null
        }
    },
    mounted() {
        if(localStorage.getItem('user_obj')) {
            this.user = JSON.parse(localStorage.getItem('user_obj'));
            // console.log(this.user);
        }
    }
}
</script>

<style>

</style>
